import { render, staticRenderFns } from "./ExportResults.vue?vue&type=template&id=2e8c070f&scoped=true&"
import script from "./ExportResults.vue?vue&type=script&lang=js&"
export * from "./ExportResults.vue?vue&type=script&lang=js&"
import style0 from "./ExportResults.vue?vue&type=style&index=0&id=2e8c070f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c070f",
  null
  
)

export default component.exports